{
    "ReportIntervalLanguageFifteenMinutes": "15 minuten",
    "ReportIntervalLanguageThirtyMinutes": "30 minuten",
    "ReportIntervalLanguageOneHour": "1 uur",
    "ReportIntervalLanguageTwoHour": "2 Uur",
    "ReportIntervalLanguageTypeMinute": "Notulen",
    "ReportIntervalLanguageTypeHour": "Uur",
    "ReportIntervalLanguageTypeHourPluralised": "Uren",
    "ReportIntervalLanguageInterpolated": "Totaal aantal oproepen door {} {}",
    "ReportIntervalLanguageCallByInterpolated": "Oproepen door {} {}",
    "ReportIntervalLanguageCallByNoValueInterpolated": "Oproepen door {}",
    "ReportIntervalTypeMinutes": "Notulen",
    "ReportIntervalTypeHours": "Uren",
    "ReportIntervalTypeDay": "Dag",
    "ReportIntervalTypeWeek": "Week",
    "ReportIntervalTypeMonth": "Maand",
    "NAME": "ReportIntervalLanguage",
    "ReportIntervalEntityLanguageCallByNoValueInterpolated": "Oproepen door {} ({})",
    "ReportIntervalEntityLanguageCallByInterpolated": "Oproepen door {} {} ({})",
    "ReportIntervalTypeDayOfTheWeek": "Dag van de week",
    "ReportIntervalEntityTypeDevicesExtensionsAA": "Apparaten (extensies\/AA)",
    "ReportIntervalEntityTypeAgents": "Agenten",
    "ReportIntervalEntityTypeGroups": "Groep\/Wachtrijen",
    "ReportIntervalEntityTypeDNIS": "DNIS"
}